var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M4,33c0-7,0-23,0-23h40v30h-8H11C11,40,4,40,4,33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    d: "M9,33h6V10H9H4c0,0,0,16,0,23c0,1.498,0.332,2.66,0.836,3.586C5.842,33.015,9,33,9,33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bbdefb",
    d: "M11,26h2V4h-2c0,0-7,0-7,7c0,6.303,0,14.97,0,22C4,26,11,26,11,26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M18 31H39V33H18zM19.707 28.707L18.293 27.293 25.5 20.086 29.5 24.086 34.793 18.793 36.207 20.207 29.5 26.914 25.5 22.914z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M32 17L38 23 38 17z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.b4a7179704ae5ddecb7835776d3fe547.svg";
export { ForwardRef as ReactComponent };